export default "__VITE_ASSET__CDoygxOG__"